import type { SupportAssignment } from "../../shared/support";

export function conversationIdentity(support: SupportAssignment | null, assistantName: string) {
  if (!support) return { name: assistantName, label: "AI product guide", notice: "AI can make mistakes. Check product details before buying." };
  if (support.replyDueAt) return {
    name: support.name,
    label: "Store team · awaiting reply",
    notice: `Waiting for ${support.name}. The AI assistant will help if they cannot reply in time.`,
  };
  // This is an explicit assignment, not a claim that every logged-in admin is available.
  return { name: support.name, label: "Store team · handling this chat", notice: `${support.name} from the store team is handling this chat.` };
}

export function conversationStarters(productName: string) {
  return productName ? [
    { label: "Find similar products", text: `Can you show me products similar to ${productName}?` },
    { label: "Help me choose", text: `Can you help me decide whether ${productName} suits my needs?` },
    { label: "Product dimensions", text: `What are the dimensions of ${productName}?` },
  ] : [
    { label: "Help me choose", text: "Can you help me choose a product?" },
    { label: "Explore furniture", text: "Help me find furniture." },
    { label: "Explore lighting", text: "Help me find lighting." },
  ];
}
